module.exports = __webpack_public_path__ + "img/header-logo.d696caff.png";